import { _get, _post } from "./Axios";

export default class DepartementApi {
    static get() {
        return _get('/masterdata/departement')
    }

    static synchronize() {
        return _post('/masterdata/departement/synchronize')
    }
}
